/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "The settings could not be loaded. Please try again." |
*
* @param {Spaces_Connection_Settings_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_load_error = /** @type {((inputs?: Spaces_Connection_Settings_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Einstellungen konnten nicht geladen werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("The settings could not be loaded. Please try again.")
});